import ColorBox from './colorbox.vue';
export default ColorBox;


// WEBPACK FOOTER //
// ./src/components/colorbox/index.js